<template>
  <div class="FormFloat">
    <FormValidation @submit="$emit('submit')">
      <div class="actions">
        <h1>
          {{ title }}
        </h1>
      </div>
      <div class="inner">
        <slot />
      </div>
    </FormValidation>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
  },
}
</script>

<style lang="scss">
.FormFloat {
  background: $white;
  margin: 0 auto;
  max-width: 32rem;
  width: 100%;

  h1 {
    color: $text-color-mid;
    font-family: $font-head;
    font-size: $h2;
    line-height: $lh * 2;
    text-align: center;
  }

  .actions {
    font-size: $h3;
    line-height: $lh;
    padding: 1.5rem;
    position: relative;
  }

  .inner {
    padding: 1rem;
    @include md {
      padding: 1.5rem;
    }

    .Btn {
      margin-bottom: 1rem;
    }
  }

  .foot {
    padding: 1rem 0;
    text-align: center;

    a {
      border-bottom: none;

      .Btn.link {
        border: none;
        display: inline-block;

        > span {
          border-bottom: 1px solid $main;
        }
      }
    }
  }

  .FormSect {
    padding: 1rem;
  }

  // margin fix if in a column
  .Column > button {
    margin: 0;
  }

  &.small-pad {
    .inner {
      padding: 0 1rem;
    }
  }
}
</style>
